export default __webpack_public_path__ + "static/media/checkers-7-rMAX.02c81277.jpg";